import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import GeneralEducationDataTable from '../../../../components/datatables/postSecondary/GeneralEducationDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface GeneralEducationListProps {
}

interface GeneralEducationListState {
}

class GeneralEducationListPage extends React.Component<GeneralEducationListProps & RouteComponentProps<RouteObject>, GeneralEducationListState> {
  constructor(props: GeneralEducationListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="General Education" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.generalEducationList()} />
        <Card >
          <GeneralEducationDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(GeneralEducationListPage);
